import React from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { DateField } from 'ui-toolkit';
import { IFieldProps } from './IFieldProps';

export const DateTo: React.FC<IFieldProps> = ({ baseName, readOnly }) => (
  <DateField
    name={`${baseName}.stringFeePropertyValues.${eFeePropertyNames.DateTo}`}
    label={'Date To'}
    placeholder={'mm/dd/yyyy'}
    data-test-id={'fee-detail-date-to'}
    readOnly={readOnly}
    attachPortalInsideContainter
  />
);
